import { createRouter, createWebHistory } from 'vue-router'
import { setPageLoading } from '@/services/api'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      redirect: '/reports'
    },
    {
      path: '/editor',
      name: 'editor',
      component: () => import('@/views/Editor/index.vue')
    },
    {
      path: '/reports',
      name: 'reports',
      component: () => import('@/views/Reports/index.vue')
    },
    {
      path: '/templates',
      name: 'templates',
      component: () => import('@/views/Templates/index.vue')
    },
    {
      path: '/template/:id',
      name: 'template-view',
      component: () => import('@/components/TemplateViewer/TemplateViewer.vue')
    },
    {
      path: '/reports/:id/slideshow',
      name: 'report-slideshow',
      component: () => import('@/components/ReportSlideshow/ReportSlideshow.vue')
    }
  ]
})

router.beforeEach((_to, _from, next) => {
  setPageLoading(true)
  next()
})

export default router
